import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  useGetMunicipalityDetailQuery,
  useUpdateMunicipalityMutation,
} from "store/services/LocationsApi/municipalityApi";
import MunicipalityForm from "./municipalityComponents/MunicipalityForm";

const MunicipalityEditScreen = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const breadcrumbs = [
    {
      title: "Municipality",
      path: "/app/crm/municipality/list",
    },
    {
      title: "Edit Municipality",
    },
  ];

  const {
    data: municipalityDetail,
    isLoading: loadingMunicipalityDetail,
    error,
  } = useGetMunicipalityDetailQuery(id);

  const [updateMunicipality, { isLoading: updatingMunicipality }] =
    useUpdateMunicipalityMutation();

  const handleMunicipalityUpdate = async (data) => {
    try {
      await updateMunicipality({
        ...data,
        id: municipalityDetail?._id,
      }).unwrap();
      toast.success("Municipality successfully updated!");
      navigate(`/app/crm/municipality/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update municipality!"
      );
    }
  };

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      loading={loadingMunicipalityDetail || updatingMunicipality}
    >
      <BreadcrumbLayout.Paper>
        <BreadcrumbLayout.Error error={error} />

        <MunicipalityForm
          municipalityDetail={municipalityDetail}
          isBusy={loadingMunicipalityDetail || updatingMunicipality}
          onSubmit={handleMunicipalityUpdate}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default MunicipalityEditScreen;
